function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Bullet List Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.0161,8 C1.5681,8 2.0161,8.448 2.0161,9 C2.0161,9.552 1.5681,10 1.0161,10 C0.4641,10 0.0001,9.552 0.0001,9 C0.0001,8.448 0.4321,8 0.9841,8 L1.0161,8 Z M15.4839,8.4839 C15.7599,8.4839 15.9839,8.7079 15.9839,8.9839 C15.9839,9.2599 15.7599,9.4839 15.4839,9.4839 L4.9839,9.4839 C4.7079,9.4839 4.4839,9.2599 4.4839,8.9839 C4.4839,8.7079 4.7079,8.4839 4.9839,8.4839 L15.4839,8.4839 Z M1.0161,4 C1.5681,4 2.0161,4.448 2.0161,5 C2.0161,5.552 1.5681,6 1.0161,6 C0.4641,6 0.0001,5.552 0.0001,5 C0.0001,4.448 0.4321,4 0.9841,4 L1.0161,4 Z M15.4839,4.4839 C15.7599,4.4839 15.9839,4.7079 15.9839,4.9839 C15.9839,5.2599 15.7599,5.4839 15.4839,5.4839 L4.9839,5.4839 C4.7079,5.4839 4.4839,5.2599 4.4839,4.9839 C4.4839,4.7079 4.7079,4.4839 4.9839,4.4839 L15.4839,4.4839 Z M1.0161,0 C1.5681,0 2.0161,0.448 2.0161,1 C2.0161,1.552 1.5681,2 1.0161,2 C0.4641,2 0.0001,1.552 0.0001,1 C0.0001,0.448 0.4321,0 0.9841,0 L1.0161,0 Z M15.4839,0.4839 C15.7599,0.4839 15.9839,0.7079 15.9839,0.9839 C15.9839,1.2599 15.7599,1.4839 15.4839,1.4839 L4.9839,1.4839 C4.7079,1.4839 4.4839,1.2599 4.4839,0.9839 C4.4839,0.7079 4.7079,0.4839 4.9839,0.4839 L15.4839,0.4839 Z",
  id: "bullet-list-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "bullet-list-Icon/Global/Menu/List",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "bullet-list-Swatches/DarkGreen",
  transform: "translate(4.000000, 7.500000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bullet-list-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bullet-list-path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "bullet-list-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#bullet-list-path-1"
})));

var SvgBulletList = function SvgBulletList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBulletList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bullet-list.be76e8f4.svg";
export { ForwardRef as ReactComponent };